/**
 * @function createVirtualLink
 * @description Create a virual link and redirects
 * @param {URL} url - URL provided in strapi
 */
export const createVirtualLink = url => {
  if (typeof window !== 'undefined') {
    const link = document?.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
